import { lighten } from "@mui/material";
import { HOME_BODY_COLOR } from "styles/oneOffColor";

const styles = {
  pageHeader: {
    position: "absolute",
    top: 0,
    right: 0,
    p: 4,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  root: {
    backgroundColor: HOME_BODY_COLOR,
  },
  userImage: {
    width: 45,
    height: 45,
    cursor: "pointer",
  },
  body: (hasBanner: boolean) => ({
    backgroundColor: "white",
    position: "absolute",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    overflowY: "auto",
    left: { xs: 0, md: "72px" },
    bottom: 0,
    top: {
      xs: hasBanner ? 100 : 60,
      md: hasBanner ? 100 : 60,
    },
  }),
  wrapper: {
    height: "100%",
    position: "relative",
    mx: 1,
    flexGrow: 1,
  },
  edit: {
    mr: 1,
    backgroundColor: "primary.main",
    width: 18,
    height: 18,
    color: "white",
    fontSize: 10,
    "&:hover": {
      backgroundColor: `${lighten("#151e16", 0.2)}`,
    },
  },
};

export default styles;
